'use strict';

var SiteActions = function (Flux, APP_DISPATCHER_ID) {

  const Actions = Flux.Actions.create('SiteActions', APP_DISPATCHER_ID);

  Actions.add({
    name: 'UpdateSite',
    purpose: 'Tells SiteStore to update a site on the DB and sync',
    payload: ['id', 'data']
  });

  Actions.add({
    name: 'DeleteSite',
    purpose: 'Tells SiteStore to delete a site from the DB and sync',
    payload: ['id', 'site']
  });

  return Actions;
};

SiteActions.$inject = ['sbFlux', 'APP_DISPATCHER_ID'];
module.exports = SiteActions;



// WEBPACK FOOTER //
// ./src/app/dash/site/SiteActions.js